export default "__VITE_ASSET__3b557db4__"